import React from "react";
import { Box, ThemeProvider } from "theme-ui";

import { useMeasure } from "hooks";
import { createTheme } from "config/theme";

export default function AppWithTheme({ children }) {
  const [ref, { width, height }] = useMeasure({
    debounce: 300,
  });

  const theme = createTheme({
    containerWidth: width,
    containerHeight: height,
  });

  return (
    <ThemeProvider theme={theme}>
      <Box
        ref={ref}
        sx={{
          width: "100%",
          height: "100%",
          position: "relative",
          display: "block !important",
          zIndex: "1",
        }}
      >
        {width > 0 && height > 0 && children}
      </Box>
    </ThemeProvider>
  );
}
